
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import HistorySignCard from '../../components/course/history-sign-card.vue'
@Component({ components: { HistorySignCard } })
export default class AddList extends Vue {
    @Prop() dialogAdd: boolean
    @Prop() student_info_id: string
    @Prop() is_show_student_info: boolean
    org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
    studentId: any = ''
    historyListArrs: any = []
    selectThemeHistoryList: any = []
    materialSelect: any = []
    materialList: any = []
    getStudentLevelList: any = []
    selectStudentLevel: string = ''
    selectLevel: string = ''
    value: string = '' // 课程记录
    historySelectlist: any = [] // 签到记录
    signHistoryList: any = []
    signPostData: any = []
    historyListData: any = []
    historySignInList: any = {}
    baseCourselist: any = []
    fullscreenLoading: boolean = true
    screenHeight: any = window.innerHeight - 100

    mounted() {
      this.getSignList() //  签到记录
    }
    @Watch('is_show_student_info')
    getDetails(oldVal, newVal) {
      if(this.is_show_student_info) {
        this.getSignList() //  签到记录
      } 
    }
    async getSignList() {
      const res: any = await CourseModule.getCourseSignList({ 'student_id': this.student_info_id, 'course_id': '', 'types': 'sign_list', 'org_id': this.org_id })
      this.historyListData = []
      if (res.code === 200) {
        this.signHistoryList = res.data.sign_list
        this.signHistoryList.forEach(item => {
          this.historyListData.push(item.student_info)
        })
        this.fullscreenLoading = false
      }
    }
}
